<template lang="pug">
  router-view
</template>

<script>
  export default {
    name: "app"
  }
</script>

<style lang="sass">
  @import "../../node_modules/flexboxgrid/dist/flexboxgrid.min.css"

  a
    text-decoration: none

</style>



// WEBPACK FOOTER //
// App.vue?6cfcdb50